
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512pt","viewBox":"0 0 512 512","width":"512pt","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M506.14 194.14l-75.995 76c-7.747 7.75-20.438 7.86-28.29 0l-76-76c-7.808-7.808-7.808-20.472 0-28.28 7.813-7.813 20.477-7.813 28.286 0L396 207.714V60c0-11.027-8.973-20-20-20H96c-11.047 0-20-8.953-20-20S84.953 0 96 0h280c33.086 0 60 26.918 60 60v147.715l41.86-41.856c7.808-7.812 20.472-7.812 28.28 0 7.813 7.809 7.813 20.473 0 28.282zM416 472H136c-11.027 0-20-8.973-20-20V304.285l41.86 41.856c7.808 7.812 20.472 7.812 28.28 0 7.813-7.809 7.813-20.473 0-28.282l-75.995-76c-7.872-7.87-20.563-7.726-28.29 0l-75.996 76c-7.812 7.809-7.812 20.473 0 28.282 7.809 7.812 20.473 7.812 28.282 0L76 304.285V452c0 33.086 26.918 60 60 60h280c11.047 0 20-8.953 20-20s-8.953-20-20-20zm0 0"}})])
          )
        }
      }
    